import { baseRealEstateUrl } from "@capcenter/shared/src/Config";

export default function buildListingURL(listingSource: any) {
    return `${baseRealEstateUrl}/homes/real-estate/${listingSource?.AddressUrlString}`;
}